<!-- 非IT资产调拨申请 -->
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<CustomTree v-if='item.Property.Control=="Custom"' :data-val='item' @child-event='handleNodeClick'></CustomTree>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<List :data-val="valData" @child-event='getListVal'></List>
		<!-- <a @click="download" href="javascript:void(0);"  id="attname" class="attname" style="color: #FF0000; text-decoration: underline">下载导入模板</a> -->
		<a href="/static/export.xlsx" download="export" style="color: #FF0000; text-decoration: underline">下载导入模板</a>
		<Button class="submit-process" v-on:click='clickSubmit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import axios from 'axios';
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import List from '../components/List.vue';
	import CustomTree from "../components/CustomTree.vue";
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		getApproverDetailInfo,
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'
	import {
		getAssetsList,
		getAssetsListFilter,
		CheckAssets
	} from '@/api/ccas'
	import {
		getDepartmentInfo,
		getDepartmentRelationByStructs,
		GetDepartmentByDepId,
		getDepartmentRelationByName,
	} from '@/api/department'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			List,
			CustomTree
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				flowId:null,
				formLoading: false,
				listLoading: false,
				valData: {
					TotalCount: 0,
					listTitle: [{
							type: 'selection',
							width: 45,
							align: 'center',
							fixed: 'left'
						},
						{
							title: '资产编号',
							key: 'AssetsCode',
							width: 120,
							disabled: true
						},
						{
							title: '供应商',
							key: 'SupplierName',
							width: 220,
							disabled: true
						},
						{
							title: '规格型号',
							key: 'AssetsSpecMode',
							width: 120,
							disabled: true
						},
						{
							title: '资产名称',
							key: 'AssetsName',
							width: 180,
							disabled: true
						},
						{
							title: '单位',
							key: 'UnitName',
							width: 180,
							disabled: true
						},
						{
							title: '资产类别',
							key: 'AssetsTypeName',
							width: 120,
							disabled: true
						},
						{
							title: '位置',
							key: 'DepartPositionName',
							width: 120,
							disabled: true
						},
						{
							title: '部门',
							key: 'UseDepartName',
							width: 120,
							disabled: true
						},
						{
							title: '价格',
							key: 'AssetsPrice',
							width: 70,
							disabled: true
						},
						{
							title: '状态',
							key: 'AssetsStateName',
							width: 70,
							disabled: true
						},
						{
							title: '入库日期',
							key: 'InStoreTime',
							width: 90,
							disabled: true
						},
						{
							title: '资产级别',
							key: 'AssetsLevelName',
							width: 80,
							disabled: true
						},
						{
							title: '资产来源',
							key: 'AssetsSourceName',
							width: 80,
							disabled: true
						},
						{
							title: '财务编号',
							key: 'FinancialCode',
							width: 120,
							disabled: true
						},
						{
							title: '数量',
							key: 'Number',
							width: 90,
							disabled: false
						},
						{
							title: '资产ID',
							key: 'AssetsId',
							width: 90,
							disabled: true
						}
					],
					listData: [],
					selectionArr:[],
          // 住宅部父id
          ZZBBASEID: null,
          // 工商铺父id
          GSPBASEID: null
				}
			}
		},
		created() {
			initWxConfig(this);
			this.ZZBBASEID = "90485687-D892-4329-8242-E7D97AFE8ADE";
			this.GSPBASEID = "2E8B3FC9-9118-4782-975A-070924ABE7C4";
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.flowId = this.$route.query.flowId;
			this.getEmployeeRelation(this.logInfo.EmpNo);
			stringUtils.setAddIsShow(true);
		},

		methods: { //方法
			handleNodeClick(dataVal, data) {
				var that = this;
				if (dataVal.Property.Title[0].Text == "调入部门") {
					this.templateData.TemplateContent.Controls.forEach((item) => {
						if (item.Property.Title[0].Text == "调入行政主任审批") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "调入大战区区董") {
							item.IsShow = false;
						}
					});
					that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
						if (item.Property.Title[0].Text == "调入审批条件") {
						  if(data.parentid === that.ZZBBASEID){
                console.log("住宅部")
						    // 住宅部
                item.Value = "option-1600853097542";
                item.IsShow = false;
                this.templateData.TemplateContent.Controls.forEach((tihsData) => {
                  if (tihsData.Property.Title[0].Text == "调入部门行政主任审批") {
                    tihsData.IsShow = true;
                  }
                  if (tihsData.Property.Title[0].Text == "调入大战区区董") {
                    tihsData.IsShow = true;
                  }
                });
              }else if(data.parentid === that.GSPBASEID){
						    //工商铺
                item.Value = "option-1600853129651";
                item.IsShow = false;
              }
							// if (dataVal.Value.indexOf("分行") > -1) {
								if (dataVal.Value.indexOf("商业地产部") > -1) {
									item.Value = "option-1600853129651";
									item.IsShow = false;
								}
								// else {
								// 	item.Value = "option-1600853097542";
								// 	item.IsShow = false;
								// 	this.templateData.TemplateContent.Controls.forEach((tihsData) => {
								// 		if (tihsData.Property.Title[0].Text == "调入部门行政主任审批") {
								// 			tihsData.IsShow = true;
								// 		}
								// 		if (tihsData.Property.Title[0].Text == "调入大战区区董") {
								// 			tihsData.IsShow = true;
								// 		}
								// 	});
								// }
							// }
							if (data.code.indexOf("KD01.0003") > -1 || data.code.indexOf("KD01.0008") > -1) { //"房友圈"
								item.Value = "option-1600853097541";
								item.IsShow = false;
								// alert("KD01.0003");
							}
							if (data.code.indexOf("KD01.0004") > -1) { //"汇瀚"
								item.Value = "option-1600853128980";
								item.IsShow = false;
								// alert("KD01.0004");
							}
							if (data.code.indexOf("KD01.0001.0001") > -1 || data.code.indexOf("KD01.0005.0001") || data.code.indexOf("KD01.0001")) { //"非营业"
								item.Value = "option-1600853146435";
								item.IsShow = false;
								for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
									var insertData = that.templateData.TemplateContent.Controls[i];
									if (insertData.Property.Title[0].Text == "调入部门经理") {
                    					insertData.Values = [];
										await GetDepartmentByDepId(data.id, false).then(res => {
											if (res.Body != null) {
												for (const depData of res.Body[0].Nodes) {
													if (depData.Items != null) {
														for (const userData of depData.Items) {
														  if (userData.JobLevel > 8  || userData.JobLevel < 4){
														    continue
                              }
														  if (JSON.stringify(insertData.Values).indexOf(userData.EmpNo) !== -1){
														    continue
                              }
                              var insertDat = [userData.EmpNo, userData.EmpName]
                              insertData.Values.push(insertDat);
														}
                          }
												}
                      } else {
												insertData.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
										if(null==insertData.Values || insertData.Values.length<=0){
											insertData.Values = [["SC24000029", "钟志斌"]]
										}
                    					console.log(insertData.Values)
									}
								}
								// alert("KD01.0001.0001");
							}
              console.log(data.code)
							if (data.code.indexOf("KD01.0001.0002.0004") > -1) { //"住宅部"
								item.Value = "option-1600853097542";
								item.IsShow = false;
								for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
									var insertData = that.templateData.TemplateContent.Controls[i];
									if (insertData.Property.Title[0].Text == "调入部门行政主任审批") {
										await GetDepartmentByDepId(data.id, false).then(res => {
											if (res.Body != null) {
												res.Body[0].Nodes.forEach((depData) => {
													if (depData.Items != null) {
														depData.Items.forEach((userData) => {
															if (userData.PositionName.indexOf("行政主任") > -1) {
																insertData.Values = [];
																var insertDat = [userData.EmpNo, userData.EmpName]
																insertData.Values.push(insertDat);
															}
														})
													}
												});
											} else {
												insertData.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
									}
									if (insertData.Property.Title[0].Text == "调入大战区区董") {
										await GetDepartmentByDepId(data.id, true).then(res => {
                      console.log(res)
											if (res.Body != null) {
												res.Body[0].Nodes.forEach((depData) => {
													if (depData.Items != null) {
														depData.Items.forEach((userData) => {
															if (userData.PositionName == "高级董事总经理") {
																insertData.Values = [];
																var insertDat = [userData.EmpNo, userData.EmpName]
																insertData.Values.push(insertDat);
															}
														})
													}
												});
											} else {
												insertData.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
									}
								}
								// alert("KD01.0001.0002.0004");
							}
							if (data.code.indexOf("KD01.0001.0002.0003") > -1) { //"工商铺"
								item.Value = "option-1600853129651";
								item.IsShow = false;
								// alert("KD01.0001.0002.0003");
							}
							if (data.code.indexOf("KD01.0001.0002.0001") > -1 || data.code.indexOf("KD01.0006") > -1) { //"二级市场"
								item.Value = "option-1600853129379";
								item.IsShow = false;
								// alert("KD01.0001.0002.0001");
							}
						}
					})
				}
				if (dataVal.Property.Title[0].Text == "调出部门") {
					this.templateData.TemplateContent.Controls.forEach((item) => {
						if (item.Property.Title[0].Text == "调出部门行政主任审批") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "调出大战区区董") {
							item.IsShow = false;
						}
					});
					that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
						if (item.Property.Title[0].Text == "调出审批条件") {
              if(data.parentid == that.ZZBBASEID){
                // 住宅部
                item.Value = "option-1600852818696";
                item.IsShow = false;
                this.templateData.TemplateContent.Controls.forEach((tihsData) => {
                  if (tihsData.Property.Title[0].Text == "调出部门行政主任审批") {
                    tihsData.IsShow = true;
                  }
                  if (tihsData.Property.Title[0].Text == "调出大战区区董") {
                    tihsData.IsShow = true;
                  }
                });
              }else if(data.parentid === that.GSPBASEID){
                //工商铺
                item.Value = "option-1602209735271";
                item.IsShow = false;
              }
							// if (dataVal.Value.indexOf("分行") > -1) {
							// 	if (dataVal.Value.indexOf("工商铺") > -1) {
							// 		item.Value = "option-1602209735271";
							// 		item.IsShow = false;
							// 	} else {
							// 		item.Value = "option-1600852818696";
							// 		item.IsShow = false;
							// 		this.templateData.TemplateContent.Controls.forEach((tihsData) => {
							// 			if (tihsData.Property.Title[0].Text == "调出部门行政主任审批") {
							// 				tihsData.IsShow = true;
							// 			}
							// 			if (tihsData.Property.Title[0].Text == "调出大战区区董") {
							// 				tihsData.IsShow = true;
							// 			}
							// 		});
							// 	}
							// }
							if (data.code.indexOf("KD01.0003") > -1 || data.code.indexOf("KD01.0008") > -1) { //"房友圈"
								item.Value = "option-1600852818695";
								item.IsShow = false;
								// alert("KD01.0003");
							}
							if (data.code.indexOf("KD01.0004") > -1) { //"汇瀚"
								item.Value = "option-1600852859702";
								item.IsShow = false;
								// alert("KD01.0004");
							}
							if (data.code.indexOf("KD01.0001.0001") > -1 || data.code.indexOf("KD01.0005.0001") || data.code.indexOf("KD01.0001")) { //"非营业" "中国大陆华西区总裁办" “四川中原物业顾问有限公司“”
								item.Value = "option-1602209735274";
								item.IsShow = false;
								for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
									var insertData = that.templateData.TemplateContent.Controls[i];
									if (insertData.Property.Title[0].Text == "调出部门经理") {
										insertData.Values = [];
										await GetDepartmentByDepId(data.id, false).then(res => {
											if (res.Body != null) {
												for (const depData of res.Body[0].Nodes) {
													if (depData.Items != null) {
														for (const userData of depData.Items) {
															if (userData.JobLevel > 8  || userData.JobLevel < 4){
																continue
															}
															if (JSON.stringify(insertData.Values).indexOf(userData.EmpNo) !== -1){
																continue
															}
															var insertDat = [userData.EmpNo, userData.EmpName]
															insertData.Values.push(insertDat);
														}
													}
												}
											} else {
												insertData.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
										if(null==insertData.Values || insertData.Values.length<=0){
											insertData.Values = [["SC24000029", "钟志斌"]]
										}
										console.log(insertData.Values)
									}
								}
								// alert("KD01.0001.0001");
							}
							if (data.code.indexOf("KD01.0001.0002.0004") > -1) { //"住宅部"
								item.Value = "option-1600852818696";
								item.IsShow = false;
								for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
									var insertData = that.templateData.TemplateContent.Controls[i];
									if (insertData.Property.Title[0].Text == "调出部门行政主任审批") {
										await GetDepartmentByDepId(data.id, false).then(res => {
											if (res.Body != null) {
												res.Body[0].Nodes.forEach((depData) => {
													if (depData.Items != null) {
														depData.Items.forEach((userData) => {
															if (userData.PositionName.indexOf("行政主任") > -1) {
																insertData.Values = [];
																var insertDat = [userData.EmpNo, userData.EmpName]
																insertData.Values.push(insertDat);
															}
														})
													}
												});
											} else {
												insertData.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
									}
									if (insertData.Property.Title[0].Text == "调出大战区区董") {
										await GetDepartmentByDepId(data.id, true).then(res => {
											if (res.Body != null) {
												res.Body[0].Nodes.forEach((depData) => {
													if (depData.Items != null) {
														depData.Items.forEach((userData) => {
															if (userData.PositionName == "高级董事总经理") {
																insertData.Values = [];
																var insertDat = [userData.EmpNo, userData.EmpName]
																insertData.Values.push(insertDat);
															}
														})
													}
												});
											} else {
												insertData.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
									}
									if (insertData.Property.Title[0].Text == "部门主管") {
										await GetDepartmentByDepId(data.id, false).then(res => {
											if (res.Body != null) {
												res.Body[0].Nodes.forEach((depData) => {
													if (depData.Items != null) {
														depData.Items.forEach((userData) => {
															if (userData.PositionName.indexOf("主管") > -1) {
																insertData.Values = [];
																var insertDat = [userData.EmpNo, userData.EmpName]
																insertData.Values.push(insertDat);
															}
														})
													}
												});
											} else {
												insertData.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
									}
								}
								// alert("KD01.0001.0002.0004");
							}
							if (data.code.indexOf("KD01.0001.0002.0003") > -1) { //"工商铺"
								item.Value = "option-1602209735271";
								item.IsShow = false;
								// alert("KD01.0001.0002.0003");
							}
							if (data.code.indexOf("KD01.0001.0002.0001") > -1 || data.code.indexOf("KD01.0006") > -1) { //"二级市场"
								item.Value = "option-1602209735272";
								item.IsShow = false;
								// alert("KD01.0001.0002.0001");
							}
						}
					})
				}
			},
			download() {
				axios.get('static/export.xlsx', {
					responseType: 'blob', //重要
				}).then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					let fname = '导入模板.xlsx';
					link.href = url;
					link.setAttribute('download', fname);
					document.body.appendChild(link);
					link.click();
				});
			},
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var user = res.result.userList[0];
						dataVal.Values = [];
						dataVal.Values.push([user.id, user.name]);
						dataVal.Value = user.name;
					}
				})
			},
			getListVal: async function(data, type) {
				var that = this;
				var classCid =
					"74ca9320-c3a4-4b0b-8b74-4c5f8b56195a,ae1b2569-b905-45a8-a2f1-0f6de5310383,71c3af89-9661-4b5a-aa1b-b213d348efc5,8801b48f-728d-4cd4-9ad2-91fdc5255484"
				if ("search" == type) {
					await getAssetsList(1, classCid, data).then(res => {
						that.valData.listData = res.Body.Items;
					})
				} else if ("changePages" == type) {
					await getAssetsList(data, classCid, "").then(res => {
						that.valData.listData = res.Body.Items;
					})
				} else if ("changeData" == type) {
					 this.fromData = data;
				}
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var that = this;
				var classCid =
					"74ca9320-c3a4-4b0b-8b74-4c5f8b56195a,ae1b2569-b905-45a8-a2f1-0f6de5310383,71c3af89-9661-4b5a-aa1b-b213d348efc5,8801b48f-728d-4cd4-9ad2-91fdc5255484"
				await getAssetsList(1, classCid, '').then(res => {
					that.valData.listData = res.Body.Items;
					that.valData.TotalCount = res.Body.TotalCount
				})
				await this.getFlowTemplateInfo();
				await getTemplateInfo(this.templateId).then(async response => {
					var that = this;
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach((item) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "调入部门经理") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "调入大战区区董") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "调入部门行政主任审批") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "调出部门经理") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "调出大战区区董") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "调出部门行政主任审批") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "调入位置") {
							item.Property.Control = "Selector";
							item.filterable = true;
						}
						if (item.Property.Title[0].Text == "调出位置") {
							item.Property.Control = "Selector";
							item.filterable = true;
						}
						if (item.Property.Title[0].Text == "调入部门") {
							item.Property.Control = "Custom";
						}
						if (item.Property.Title[0].Text == "调出部门") {
							item.Property.Control = "Custom";
						}
						if (item.Property.Title[0].Text == "申请内容") {
							// var apply = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "申请内容"
							// });
							// var tableList = [];
							// for(var i = 0; i < apply[0].Config.Table.Children.length;i++){
							// 	var tableApply = apply[0].Config.Table.Children[i];
							// 	tableList.push({
							// 		'text': tableApply.Property.Title[0].Text,
							// 		"val": tableApply.Value,
							// 		"disabled": true
							// 	});
							// }
							// that.valData.selectionArr = tableList;
							item.Property.Control = "List";
							//this.fromData = null;
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "调出审批条件") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "调入审批条件") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "是否提交资产软件") {
							item.IsShow = false
						}
						if (item.Property.Title[0].Text == "是否与申请内容相符") {
							item.IsShow = false;
						}
					});
					this.templateData = this.assignControl(controls, that.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, that.spNo,that.flowId);
					this.listLoading = false;
				});
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getFlowTemplateInfo: async function() {
				if (this.spNo == null || this.spNo == undefined || this.spNo.length <= 0) {
					return;
				}
				await getApproverDetailInfo(this.spNo).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			clickSubmit() {
				this.listLoading = true; //显示加载
				let that = this;
				setTimeout(function() {
					that.submit()
				}, 1000)
			},
			submit: async function() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					this.listLoading = false; //隐藏加载
					return;
				}
				var isSucc = true;
				var value = null;
				var value2 = null;
				var code = "";
				var tableData = [];
				var startIndex = -1;
				var jsonDataList = []
				var postData = {
					applyNo: "",
					applyAccount: this.logInfo.EmpNo,
					applyAccountName: this.logInfo.EmpName,
					newDeptId: "b8471755-e791-4d17-bf71-a316499ae4a9",
					safeKeepCode: "",
					newLocationId: "",
					jsonData: ""
				}
				var that = this;
				if (that.fromData == null || that.fromData.length <= 0) {
					this.listLoading = false; //隐藏加载
					that.Message({
						message: "请选择或导入资产信息",
						type: 'error',
						duration: 3 * 1000
					});
					return;
				}
				var isDelete = false;
				for (let i = this.templateData.TemplateContent.Controls.length - 1; i >= 0; i--) {
					let data = this.templateData.TemplateContent.Controls[i];
					if (data.Property.Title[0].Text.indexOf("申请内容") > -1) {
						if (isDelete) {
							this.templateData.TemplateContent.Controls.splice(i, 1);
							console.log(this.templateData.TemplateContent.Controls);
						} else {
							isDelete = true;
						}
					}
				}
				this.templateData.TemplateContent.Controls.forEach((item, index) => {
					if (item.Property.Title[0].Text.indexOf("申请内容") > -1) {
						if (that.fromData != null) {
							tableData = that.convertInTable(that.fromData, item);
						} else {
							if (item.Config.Table.Children.length == 0 || !item.IsShow) {
								this.listLoading = false; //隐藏加载
								that.Message({
									message: "请选择或导入资产信息",
									type: 'error',
									duration: 3 * 1000
								});
								return;
							}
						}
						startIndex = index;
					}
				});

				if (startIndex != -1) {
					var filter = [];
					for (var k = 0; k < tableData.length; k++) {
						code = tableData[k].Config.Table.Children.filter(t => t.Property.Title[0].Text == "资产编号")[0].Value;
						filter.push(code);
						var jsonData = {
							assetsId: "",//资产id
							newLocationID: "",//调入位置id
							newLocationName: "",//调入位置名称
							safeKeepCode: "",//调入保管人code
							safeKeepName: "",//调入保管人名称
							useUserCode: "",//调入使用人code
							useUserName: "",//调入使用人名称
							transfersSource: "调拨原因"
						}
						jsonData.assetsId = tableData[k].Config.Table.Children.filter(t => t.Property.Title[0].Text == "资产ID")[0].Value;
						jsonDataList.push(jsonData);
						if (k == 0) {
							this.templateData.TemplateContent.Controls.splice(startIndex, 1);
						}
						this.templateData.TemplateContent.Controls.splice(startIndex + k, 0, tableData[k]);
					}
					var classCid =
						"74ca9320-c3a4-4b0b-8b74-4c5f8b56195a,ae1b2569-b905-45a8-a2f1-0f6de5310383,71c3af89-9661-4b5a-aa1b-b213d348efc5,8801b48f-728d-4cd4-9ad2-91fdc5255484";
					await CheckAssets(filter, classCid).then(res => {
						if (res.ErrCode == 0 && res.Body) {
							that.Message({
								message: '成功',
								type: 'success',
								duration: 3 * 1000
							});
						} else {
							isSucc = false;
							that.Message({
								message: res.ErrMsg,
								type: 'error',
								duration: 3 * 1000
							});
							this.listLoading = false; //隐藏加载
							return;
						}
					})
					if (!isSucc) {
						this.listLoading = false; //隐藏加载
						return;
					}
				}

				this.templateData.TemplateContent.Controls.forEach((item, index) => {
					if (item.Property.Title[0].Text == "申请内容") {
						tableData = this.convertInTable(that.fromData, item);
						startIndex = index;
					}
					if (item.Property.Title[0].Text == "调出位置") {
						var newLocationId = item.value.Key.split("|")[0];
						var newLocationName = item.value.Key.split("|")[1];
						item.Value = newLocationName;
						item.Property.Control = "Text";
						value = item.value;
						delete item.value;
					}
					if (item.Property.Title[0].Text == "调入位置") {
						var newLocationId = item.value.Key.split("|")[0];
						var newLocationName = item.value.Key.split("|")[1];
						postData.newLocationId = newLocationId;
						item.Value = newLocationName;
						item.Property.Control = "Text";
            value2 = item.value;
            delete item.value;
					}
					if (item.Property.Title[0].Text == "调出部门") {
						var deptId = item.Values[0][0];
						var deptName = item.Value;
						item.Value = deptName;
						item.Property.Control = "Text";
					}
					if (item.Property.Title[0].Text == "调入部门") {
						var deptId = item.Values[0][0];
						var deptName = item.Value;
						postData.newDeptId = deptId;
						item.Value = deptName;
						item.Property.Control = "Text";
					}
					if (item.Property.Title[0].Text == "是否与申请内容相符") {
						item.IsShow = true;
					}
				});
				postData.jsonData = JSON.stringify(jsonDataList);

				// 1、申请人信息：申请人姓名+工号+部门名称
				// 2、调入部门：调入部门
				// 3、调拨原因：调拨原因
				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];

				var control1 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "人员"
				})[0]
				var control2 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "工号"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请人信息：" + control1.Value + " " + control2.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);


				var control4 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "调入部门"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "调入部门：" + control4.Values[0][1],
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control5 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "调拨原因"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "调拨原因：" + control5.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);


				this.templateData.SummaryList = SummaryList;

				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				isSubmit = true;
				this.listLoading = true;
				this.templateData.TransfersApply = postData;
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					postData.applyNo = response.Body.FlowId;
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调入位置")[0].Property.Control =
						"Selector";
          this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调入位置")[0].value = value2;
					this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调出位置")[0].Property.Control =
						"Selector";
          this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调出位置")[0].value = value;
					this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调入部门")[0].Property.Control =
						"Custom";
					this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调入部门")[0].Property.Control =
						"Custom";
					isSubmit = false;
					this.listLoading = false;
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调入位置")[0].Property.Control =
						"Selector";
					this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调出位置")[0].Property.Control =
						"Selector";
          this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调入位置")[0].value = value2;
          this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调出位置")[0].value = value;
					this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调入部门")[0].Property.Control =
						"Custom";
					this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text == "调入部门")[0].Property.Control =
						"Custom";
					isSubmit = false;
					this.listLoading = false;
				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
